import { paginationButonClass } from "./constants";
import {
  PAGINATION_BUTTON_VARIANT,
  PAGINATION_DIRECTION,
  PaginationButtonProps,
} from "./types";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import classNames from "classnames";
import { FC } from "react";

const PaginationButton: FC<PaginationButtonProps> = ({
  variant,
  handleChangePage,
  disable,
  text,
  direction,
  className,
}) => {
  return (
    <button
      className={classNames(
        paginationButonClass[variant].class,
        "flex justify-center fds-l:body-md body-sm items-center fds-sm:gap-x-1 gap-x-0.5 ",
        direction === PAGINATION_DIRECTION.LEFT
          ? "flex-row-reverse"
          : "flex-row",
        className
      )}
      onClick={handleChangePage}
      disabled={disable}
    >
      <ArrowLeft2Icon
        className={classNames(
          paginationButonClass[variant].icon,
          direction === PAGINATION_DIRECTION.RIGHT ? "rotate-180" : ""
        )}
      />
      {variant !== PAGINATION_BUTTON_VARIANT.ARROW && text}
    </button>
  );
};
export default PaginationButton;
